/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NameChangeHistoryEntry {
    getFixupPrototypeFunction() { return NameChangeHistoryEntry.fixupPrototype; }

    static newInstance(model: Partial<NameChangeHistoryEntry>): NameChangeHistoryEntry {
        let obj = Object.assign(new NameChangeHistoryEntry(), model);
        NameChangeHistoryEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NameChangeHistoryEntry>): NameChangeHistoryEntry {
        if (!model) return null;
        return NameChangeHistoryEntry.newInstance(<NameChangeHistoryEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NameChangeHistoryEntry) {
        if (!obj) return;

        models.NameChangeHistoryEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NameChangeHistoryEntry): boolean {
        Object.setPrototypeOf(obj, NameChangeHistoryEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Previous tenant name before the rename.
     */
    previous_name: string;

    /**
     * New tenant name after the rename.
     */
    new_name: string;

    /**
     * User who performed the rename.
     */
    updated_by: string;

    /**
     * DateTime in UTC when the rename was performed.
     */
    updated_at: Date;

}
